import { responseType } from "../constants";
import { NoteReply, SaveNoteReplayModel, SaveTransactionNoteModel, TransactionNote } from "../types/note/Note";
import { fetchSafe } from "./fetch.safe";

export const transactionNotesService = {
    getNotes,
    saveNote,
    deleteNote,
    ddeleteMyNotes: deleteMyNotes,
    saveNoteReply,
    deleteNoteReply
}

function getNotes(
    dealReferenceName: string,
    transactionReferenceName: string): Promise<TransactionNote[]> {
    return fetchSafe(`${process.env.REACT_APP_AMR_ENDPOINT}/api/bwic/deals/${dealReferenceName}/transactions/${transactionReferenceName}/notes`);
}

function saveNote(
    dealReferenceName: string,
    transactionReferenceName: string,
    note: SaveTransactionNoteModel): Promise<TransactionNote> {
    return fetchSafe(
        `${process.env.REACT_APP_AMR_ENDPOINT}/api/bwic/deals/${dealReferenceName}/transactions/${transactionReferenceName}/notes`, {
        method: 'POST',
        body: JSON.stringify({ ...note })
    });
}

function deleteNote(noteId: number): Promise<void> {
    return fetchSafe(
        `${process.env.REACT_APP_AMR_ENDPOINT}/api/bwic/notes/${noteId}`, {
        method: 'DELETE',
        responseType: responseType.none
    });
}

function deleteMyNotes(dealReferenceName: string, transactionReferenceName: string): Promise<void> {
    return fetchSafe(
        `${process.env.REACT_APP_AMR_ENDPOINT}/api/bwic/deals/${dealReferenceName}/transactions/${transactionReferenceName}/notes`, {
        method: 'DELETE',
        responseType: responseType.none
    });
}

function saveNoteReply(reply: SaveNoteReplayModel): Promise<NoteReply> {
    return fetchSafe(
        `${process.env.REACT_APP_AMR_ENDPOINT}/api/bwic/notes/reply`, {
        method: 'POST',
        body: JSON.stringify(reply)
    });

}

function deleteNoteReply(replyId: number): Promise<void> {
    return fetchSafe(
        `${process.env.REACT_APP_AMR_ENDPOINT}/api/bwic/notes/reply/${replyId}`, {
        method: 'DELETE',
        responseType: responseType.none
    });
}
